import { useLayoutEffect, useRef, useState } from 'react';

/**
 * Tracks element content box via ResizeObserver for responsive chart/layout sizing.
 */
export function useContainerSize(minWidth = 32, minHeight = 32) {
  const ref = useRef(null);
  const [size, setSize] = useState({ width: minWidth, height: minHeight });

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;

    const read = () => {
      const cr = el.getBoundingClientRect();
      setSize({
        width: Math.max(minWidth, Math.floor(cr.width)),
        height: Math.max(minHeight, Math.floor(cr.height)),
      });
    };

    read();
    const ro = new ResizeObserver(read);
    ro.observe(el);
    return () => ro.disconnect();
  }, [minWidth, minHeight]);

  return { ref, width: size.width, height: size.height };
}
